import { type SortingState } from "@tanstack/react-table";

import { type FarmerQuickFilterId } from "./quick-filters";

const TRANSLATION_PREFIX = "home.manager.overview.farmersModal.columns";

/** Ids are the backend `ordering` field names, so `ordering` needs no lookup table. */
export const FARMER_SORT_OPTIONS = [
  { id: "date_registered", translationKey: `${TRANSLATION_PREFIX}.dateRegistered` },
  { id: "last_profile_update", translationKey: `${TRANSLATION_PREFIX}.lastProfileUpdate` },
  { id: "full_name", translationKey: `${TRANSLATION_PREFIX}.fullName` },
  { id: "identification", translationKey: `${TRANSLATION_PREFIX}.identification` },
  { id: "gender", translationKey: `${TRANSLATION_PREFIX}.gender` },
  { id: "total_household_members", translationKey: `${TRANSLATION_PREFIX}.householdMembers` },
  { id: "total_deposits", translationKey: `${TRANSLATION_PREFIX}.totalDeposits` },
  { id: "total_events", translationKey: `${TRANSLATION_PREFIX}.totalEvents` },
  { id: "aggregator", translationKey: `${TRANSLATION_PREFIX}.aggregator` },
  { id: "admin_area", translationKey: `${TRANSLATION_PREFIX}.adminArea` },
] as const;

export const DEFAULT_PAGE_SIZE = 20;

/** Matches the backend default, so the first page is sorted before any user input. */
export const DEFAULT_ORDERING = "-date_registered";

export const DEFAULT_SORTING: SortingState = [{ id: "date_registered", desc: true }];

export const SEARCH_DEBOUNCE_MS = 300;

/** Backend gender codes, mapped to their translation key. Unknown codes render as-is. */
export const GENDER_TRANSLATION_KEYS: Record<string, string> = {
  M: "home.manager.overview.farmersModal.gender.male",
  F: "home.manager.overview.farmersModal.gender.female",
};

export interface FarmersQuery {
  aggregator?: string;
  page: number;
  search: string;
  sorting: SortingState;
  quickFilter: FarmerQuickFilterId | null;
}

export const buildFarmersParams = ({
  aggregator,
  page,
  search,
  sorting,
  quickFilter,
}: FarmersQuery) => ({
  page,
  page_size: DEFAULT_PAGE_SIZE,
  ordering: sorting[0] ? `${sorting[0].desc ? "-" : ""}${sorting[0].id}` : DEFAULT_ORDERING,
  ...(search ? { search } : {}),
  // The endpoint rejects more than one tile filter, which a single selection cannot produce.
  ...(quickFilter ? { [quickFilter]: true } : {}),
  ...(aggregator ? { aggregator } : {}),
});
